var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.STOCK_DISTRIBUTION_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockDistributionPlan.header.code"
                          ),
                          prop: "code",
                        },
                      },
                      [
                        _c("BjInputCode", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockDistributionPlan.header.code"
                            ),
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "code", $$v)
                            },
                            expression: "queryParams.code",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("table.statusText"),
                          prop: "status",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.isVerify
                              ? _vm.STOCK_DISTRIBUTE_PLAN_STATUS.slice(0, 2)
                              : _vm.STOCK_DISTRIBUTE_PLAN_STATUS,
                            placeholder: _vm.$t("table.statusText"),
                          },
                          model: {
                            value: _vm.queryParams.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "status", $$v)
                            },
                            expression: "queryParams.status",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockDistributionPlan.header.receiveWarehouseIdList"
                          ),
                          prop: "receiveWarehouseIdList",
                        },
                      },
                      [
                        _c("BjSelectWarehouse", {
                          attrs: {
                            multiple: "",
                            "type-code": [
                              "default-virtual",
                              "qty-virtual",
                              "interline-virtual",
                            ],
                            placeholder: _vm.$t(
                              "BusinessStockDistributionPlan.header.receiveWarehouseIdList"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.receiveWarehouseIdList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryParams,
                                "receiveWarehouseIdList",
                                $$v
                              )
                            },
                            expression: "queryParams.receiveWarehouseIdList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("form.startDateText"),
                          prop: "beginStartDate",
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: { placeholder: _vm.$t("form.startDateText") },
                          model: {
                            value: _vm.queryParamsStartTime,
                            callback: function ($$v) {
                              _vm.queryParamsStartTime = $$v
                            },
                            expression: "queryParamsStartTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("form.endDateText"),
                          prop: "endStartDate",
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: { placeholder: _vm.$t("form.endDateText") },
                          model: {
                            value: _vm.queryParamsEndTime,
                            callback: function ($$v) {
                              _vm.queryParamsEndTime = $$v
                            },
                            expression: "queryParamsEndTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    !_vm.isVerify
                      ? _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName:
                                  "v-permission:BusinessStockDistributionPlanAdd",
                                arg: "BusinessStockDistributionPlanAdd",
                              },
                            ],
                            staticClass: "main-btn",
                            attrs: { type: "primary" },
                            on: { click: _vm.onAdd },
                          },
                          [_vm._v(_vm._s(_vm.$t("addText")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "status"
                                      ? [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.STOCK_DISTRIBUTE_PLAN_STATUS.bjGet(
                                                  scope.row[col.prop]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value: !_vm.isVerify
                                              ? "BusinessStockDistributionPlanView"
                                              : "BusinessStockVerifyPlanView",
                                            expression:
                                              "\n                !isVerify ? 'BusinessStockDistributionPlanView' : 'BusinessStockVerifyPlanView'\n              ",
                                          },
                                        ],
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onView(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("viewText")))]
                                    ),
                                    !_vm.isVerify
                                      ? [
                                          scope.row.status == "wait"
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:BusinessStockDistributionPlanEdit",
                                                      arg: "BusinessStockDistributionPlanEdit",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    text: _vm.$t(
                                                      "BusinessStockDistributionPlan.pageText1"
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onEdit(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("editText"))
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          ["fail", "cancel"].includes(
                                            scope.row.status
                                          )
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:BusinessStockDistributionPlanIndex_Reset",
                                                      arg: "BusinessStockDistributionPlanIndex_Reset",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    text: _vm.$t(
                                                      "BusinessStockDistributionPlan.pageText2"
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onStatus(
                                                        "wait",
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("resetText"))
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          scope.row.status == "underway"
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:BusinessStockDistributionPlanIndex_Discard",
                                                      arg: "BusinessStockDistributionPlanIndex_Discard",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    text: _vm.$t(
                                                      "BusinessStockDistributionPlan.pageText3"
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onStatus(
                                                        "abandon",
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "BusinessStockDistributionPlan.btn"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          scope.row.status == "wait"
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:BusinessStockDistributionPlanIndex_Cancel",
                                                      arg: "BusinessStockDistributionPlanIndex_Cancel",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    text: _vm.$t(
                                                      "BusinessStockDistributionPlan.pageText4"
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onStatus(
                                                        "cancel",
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("cancelText"))
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      : [
                                          scope.row.status == "wait"
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:BusinessStockVerifyPlanIndex_Pass",
                                                      arg: "BusinessStockVerifyPlanIndex_Pass",
                                                    },
                                                  ],
                                                  staticClass: "main-btn",
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onAudit(
                                                        "pass",
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("approvedText")
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          scope.row.status == "wait"
                                            ? _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "permission",
                                                      rawName:
                                                        "v-permission:BusinessStockVerifyPlanIndex_Reject",
                                                      arg: "BusinessStockVerifyPlanIndex_Reject",
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onAudit(
                                                        "reject",
                                                        scope.row.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("auditRejectText")
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }